export const API_BASE_URL = 
    process.env.REACT_APP_BASE_URL_PROD
    // process.env.REACT_APP_BASE_URL_UAT_IIS
    // `http://localhost:5002`
    // `http://localhost:5000`
    // `http://localhost:8000`
    // `http://localhost:8080`
    // `http://localhost:8081`

export const IMAGE_BASE_URL = API_BASE_URL;
export const STORE_OPEN_TIME = "10:00";
export const STORE_CLOSE_TIME = "21:30"; // 09:30PM // ORIGINAL
// export const STORE_CLOSE_TIME = "24:00"; // 10:30PM
export const GUEST_LOGIN_TIME = {
    MIDNIGHT: 0,     // 12:00 AM
    TEN_AM: 10 * 60, // 10:00 AM
    TEN_PM: 22 * 60, // 10:00 PM // ORIGINAL

    // TEN_PM: 24 * 60, // 11:30 PM
} as const;